import { createRef } from 'react';

const _fullChart = createRef();

export default _fullChart;
